<template>
  <div style="display:grid; min-height:100vh;">
    <!-- <loading
          :active.sync="isLoading"
          :can-cancel="false"
          loader="dots"
          :is-full-page="fullPage"
          :height="height"
          :width="width"
          background-color="#6b6969"
        ></loading>-->
    <green-nav />
    <div class="section section-basic mt-5">
      <div class="custom-container-fluid">
        <div class="row" style="margin-top: 2rem">
          <div class="col-md-12">
            <iframe
              v-if="src"
              title="Ghana ladies in tech registration"
              onload="window.parent.scrollTo(0,0)"
              allowtransparency="true"
              allow="geolocation; microphone; camera"
              :src="src"
              style="width: 1px;
min-width: 100%;
height: 70rem;
border:none;"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import Swal from "sweetalert2";
import GreenNav from "../components/navbar_green";
import downFooter from "../components/footer";
import axios from "axios";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128,
      src: "https://form.jotform.com/212553233249553"
    };
  },
  components: {
    // Loading,
    downFooter,
    GreenNav
  },

  methods: {
    formatDate(d) {
      return moment(d).format("MMM");
    },
    getDayFromDate(d) {
      return d ? moment(d).format("D") : "";
    },
    getFullDate(d) {
      return d ? moment(d).format("DD MMM YYYY") : "";
    },
    getEvents() {
      this.isLoading = true;
      axios
        .get(
          "https://ladies-in-tech-webservice.azurewebsites.net/all-activities"
        )
        .then(res => {
          const { data } = res;
          this.events = data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  created() {

    document.body.style.background = "#ffffff";
  }
};
</script>

<style scoped>
.b-items__cars-one-img-type {
  border-radius: 5px;
  font: 700 10px "Open Sans", sans-serif;
  padding: 2px 5px;
  text-transform: uppercase;
  position: absolute;
  /* top: 15px; */
  z-index: 1000;
  background: white;
  top: 20px;
  left: 20px;
}
@media screen and (max-width: 768px) {
  .sm-none {
    display: none;
  }
}
@media screen and (min-width: 769px) {
  .md-none {
    display: none;
  }
}
</style>
